import { render, staticRenderFns } from "./finalPayment.vue?vue&type=template&id=6d054281&"
import script from "./finalPayment.vue?vue&type=script&lang=ts&"
export * from "./finalPayment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports